/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import * as MUI from "@mui/material";
import * as Icon from "@mui/icons-material";
import moment from "moment";

import { useAuth } from "../../../hooks/auth";
import {
  getCarcerario,
  getFoto,
} from "../../../services/apiConsultaCarcerario";
import {
  DadosFichaCarcerario,
  IEndereco,
  IProcessos,
} from "../../../interface/fichaCarcerario";

import { LabelInfo } from "../../../components";

interface PropsId {
  DET_ID: string;
}

interface Processos {
  PROCESSOS: string;
}

const styleInputs = {
  display: "flex",
  flexDirection: "row",
  gap: 1,
};

export const FichaCarceraria: React.FC = () => {
  const history = useHistory();
  const { params } = useRouteMatch<PropsId>();

  const [dados, setDados] = useState<DadosFichaCarcerario[]>([]);
  const [endereco, setEndereco] = useState<IEndereco | null>(null);
  const [processos, setProcessos] = useState<Processos[] | null>(null);
  const [foto1, setFoto1] = useState<string | null>(null);
  const [foto2, setFoto2] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const { logout, user } = useAuth();

  useEffect(() => {
    function getFotoCarcerario() {
      getFoto(params.DET_ID).then((res) => {
        setFoto1(res.data.foto1);
        setFoto2(res.data.foto2);
      });
    }
    getFotoCarcerario();
  }, []);

  useEffect(() => {
    function consultaFichaCarceraria() {
      getCarcerario(params.DET_ID)
        .then((response) => {
          if (response.status === 200) {
            setDados(response.data);
            setEndereco(response.data[0].ENDERECO[0]);
            setProcessos(response.data[0].PROCESSOS);
          }
          if (response.status === 404) {
            toast.error("HOUVE ALGUM ERRO NA REQUISIÇÃO, TENTE NOVAMENTE.", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 500 || response.status === 503) {
            toast.error("ERRO NO SERVIDOR, TENTE MAIS TARDE!", {
              position: toast.POSITION.TOP_CENTER,
              autoClose: 4000,
            });
          }
          if (response.status === 504) {
            toast.error(
              "O SERVIDOR DEMOROU MUITO PARA RESPONDER, TENTE NOVAMENTE EM INSTANTES.",
              {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 4000,
              }
            );
          }
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          toast.error("ERRO DE CONEXÃO! VERIFIQUE SUA INTERNET!", {
            position: toast.POSITION.TOP_CENTER,
            autoClose: 4000,
          });
        });
    }
    consultaFichaCarceraria();
  }, []);

  const imprimir = () => {
    window.print();
  };

  const voltar = () => {
    history.goBack();
  };

  const theme = MUI.useTheme();

  return (
    <MUI.Stack
      pt={[2, 0]}
      flexDirection="row"
      width="100%"
      height="80vh"
      overflow="auto"
      sx={{
        "@media print": {
          overflow: "hidden !important",
          height: "100%",
          pageBreakInside: "avoid",
        },
      }}
    >
      <MUI.Stack p={2} flex={1}>
        <MUI.Stack
          mb={1}
          gap={[1, 0]}
          width="100%"
          flexDirection={["column", "row"]}
          justifyContent="space-between"
          sx={{
            displayPrint: "none",
          }}
        >
          <MUI.Button
            variant="contained"
            startIcon={<Icon.KeyboardReturn />}
            onClick={voltar}
          >
            Voltar para pesquisa
          </MUI.Button>
          <MUI.Button variant="contained" onClick={imprimir}>
            Imprimir
          </MUI.Button>
        </MUI.Stack>
        {!loading ? (
          <>
            {foto1 || foto2 ? (
              <MUI.Stack
                flex={1}
                mb={1}
                gap={3}
                alignItems="center"
                justifyContent={["center", "inherit"]}
                flexDirection={["column", "row"]}
                sx={{
                  "@media print": {
                    flexDirection: "row",
                  },
                }}
              >
                {foto1 && (
                  <MUI.Stack height="16rem">
                    <MUI.Avatar
                      imgProps={{
                        sx: {
                          width: "150px",
                          height: "200px",
                          objectFit: "fill",
                          "&:hover": {
                            width: "250px",
                            height: "270px",
                          },
                        },
                      }}
                      variant="rounded"
                      src={`data:image/jpeg;base64,${foto1}`}
                      alt="FOTO"
                      sx={{
                        width: "auto",
                        height: "265px",
                      }}
                    />
                  </MUI.Stack>
                )}

                {foto2 && (
                  <MUI.Stack height="16rem">
                    <MUI.Avatar
                      imgProps={{
                        sx: {
                          width: "150px",
                          height: "200px",
                          objectFit: "fill",
                          "&:hover": {
                            width: "250px",
                            height: "270px",
                          },
                        },
                      }}
                      variant="rounded"
                      src={`data:image/jpeg;base64,${foto2}`}
                      alt="FOTO"
                      sx={{
                        width: "auto",
                        height: "265px",
                      }}
                    />
                  </MUI.Stack>
                )}
              </MUI.Stack>
            ) : (
              false
            )}

            {dados &&
              dados.map((usuario) => (
                <MUI.Stack pb={2} key={usuario.DET_ID}>
                  <MUI.Typography
                    bgcolor={theme.palette.secondary.light}
                    variant="h6"
                  >
                    Ficha Cadastro Carcerário
                  </MUI.Typography>
                  <MUI.Divider
                    sx={{
                      borderWidth: 1.5,
                      backgroundColor: "black",
                    }}
                  />
                  <MUI.Grid container spacing={1} py={1}>
                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Nome Completo:"
                        info={usuario.FOLHAROSTO.NOME}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Protuário:"
                        info={usuario.FOLHAROSTO.PRONTUARIO}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label=" Classe delinquente:"
                        info={usuario.FOLHAROSTO.CLASSE || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Situação:"
                        info={usuario.SITUACAO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label=" Descrição resumida:"
                        info={usuario.TAB_DESCRICAORESUMIDA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="vulgo:"
                        info={usuario.FOLHAROSTO.VULGO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Idade:"
                        info={usuario.FOLHAROSTO.IDADE || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label=" Data de nascimento:"
                        info={
                          moment(usuario.FOLHAROSTO.DATANASCIMENTO).format(
                            "DD/MM/YYYY "
                          ) || "Não informado"
                        }
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label=" Nome pai:"
                        info={usuario.FOLHAROSTO.PAI || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Nome mãe:"
                        info={usuario.FOLHAROSTO.MAE || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label=" Olhos:"
                        info={usuario.FOLHAROSTO.OLHOS || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Barba:"
                        info={usuario.FOLHAROSTO.BARBA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Bigode:"
                        info={usuario.FOLHAROSTO.BIGODE || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Dentes:"
                        info={usuario.FOLHAROSTO.DENTES || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Orelhas:"
                        info={usuario.FOLHAROSTO.ORELHA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Boca:"
                        info={usuario.FOLHAROSTO.BOCA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Nariz:"
                        info={usuario.FOLHAROSTO.NARIZ || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Lábios:"
                        info={usuario.FOLHAROSTO.LABIOS || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Sombrancelhas:"
                        info={usuario.FOLHAROSTO.SOMBRA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Altura:"
                        info={usuario.FOLHAROSTO.ALTURA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Cútis:"
                        info={usuario.FOLHAROSTO.CUTIS || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Cabelo:"
                        info={usuario.FOLHAROSTO.CORCABELO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Tipo cabelo:"
                        info={usuario.FOLHAROSTO.CABELOTIPO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Nacionalidade:"
                        info={
                          usuario.FOLHAROSTO.NACIONALIDADE || "Não informado"
                        }
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Naturalidade:"
                        info={usuario.FOLHAROSTO.DET_PAIS || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Estado civil:"
                        info={usuario.FOLHAROSTO.ESTADOCIVIL || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Filhos:"
                        info={usuario.FOLHAROSTO.QTDFILHOS || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Profissão:"
                        info={usuario.FOLHAROSTO.PROFISSAO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Estado Econômico:"
                        info={
                          usuario.FOLHAROSTO.ESTADOECONOMICO || "Não informado"
                        }
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Escolaridade:"
                        info={
                          usuario.FOLHAROSTO.ESCOLORIDADE || "Não informado"
                        }
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Pavilhão:"
                        info={usuario.FOLHAROSTO.PAVILHAO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Cela:"
                        info={usuario.FOLHAROSTO.CELA || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Profissão:"
                        info={usuario.FOLHAROSTO.PROFISSAO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="RG:"
                        info={usuario.DET_RG || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Sexo:"
                        info={
                          usuario.DET_SEXO === "M" ? "Masculino" : "Feminino"
                        }
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Endereço:"
                        info={endereco?.END_LOGRADOURO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Bairro:"
                        info={endereco?.END_BAIRRO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="Cidade:"
                        info={endereco?.MUN_DESCRICAO || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="CEP:"
                        info={endereco?.END_CEP || "Não informado"}
                      />
                    </MUI.Grid>

                    <MUI.Grid xs={12} sm={6} md={4} item sx={styleInputs}>
                      <LabelInfo
                        label="UF:"
                        info={endereco?.EST_SIGLA || "Não informado"}
                      />
                    </MUI.Grid>
                  </MUI.Grid>
                  {dados.map((cidadao) => (
                    <>
                      <MUI.Grid xs={12} sm={6} md={6} item sx={styleInputs}>
                        <LabelInfo
                          label="Unidade:"
                          info={
                            cidadao.UNIDADES.UPE_SIGLAUNIDADE || "Não informado"
                          }
                        />
                      </MUI.Grid>
                      <MUI.Grid xs={12} sm={6} md={6} item sx={styleInputs}>
                        <LabelInfo
                          label="Denominação"
                          info={
                            usuario.UNIDADES.UPE_DENOMINACAO || "Não informado"
                          }
                        />
                      </MUI.Grid>
                    </>
                  ))}

                  {dados.map((cidadao) => (
                    <>
                      <MUI.Grid xs={12} md={12} sm={12} item>
                        <LabelInfo
                          label="OBS:"
                          info={cidadao.FOLHAROSTO.OBS || "Não informado"}
                        />
                      </MUI.Grid>
                    </>
                  ))}

                  {dados.map((cidadao) => (
                    <>
                      <MUI.Grid xs={12} md={12} sm={12} item>
                        <LabelInfo
                          label="Histórico penal:"
                          info={cidadao.HISTORICO || "Não informado"}
                        />
                      </MUI.Grid>
                    </>
                  ))}
                  <MUI.Grid xs={12} md={12} sm={12} item>
                    <MUI.Typography fontWeight="bold" variant="body1">
                      Dados processuais:
                    </MUI.Typography>
                    {processos &&
                      processos?.map((processo) => (
                        <MUI.Typography variant="body1">
                          {processo.PROCESSOS}
                        </MUI.Typography>
                      ))}
                  </MUI.Grid>
                </MUI.Stack>
              ))}
          </>
        ) : (
          <MUI.LinearProgress />
        )}
      </MUI.Stack>
    </MUI.Stack>
  );
};
